import { createFileRoute, linkOptions } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import type { CoverageResponse } from 'types'

import NotFoundResource from '@/components/router/not-found-resource'
import PolicySheetContent from '@/components/sheets/policy/policy-sheet-content'
import { policySheetPreload } from '@/components/sheets/policy/policy-sheet-preload'
import { ViewTransitionType } from '@/css/view-transition.types'

export const Route = createFileRoute('/app/data/groups/$uuid/$policyUuid/')({
  component: RouteComponent,
  loader: ({ params, context: { queryClient } }) =>
    policySheetPreload(params.policyUuid, queryClient),
  errorComponent: (props) => {
    const { t } = useTranslation()

    return (
      <NotFoundResource
        {...props}
        resourceType={t('resource-not-found.not-found.policy.resource-type')}
        backTo={t('resource-not-found.not-found.policy.back-to-policies-list')}
        backToLink={backLink}
      />
    )
  },
})

const backLink = linkOptions({
  from: Route.fullPath,
  to: '..',
  viewTransition: { types: [ViewTransitionType.SheetChildToParent] },
})

const coverageRowLink = (coverage: CoverageResponse) =>
  linkOptions({
    from: Route.fullPath,
    to: '/app/data/groups/$uuid/$policyUuid/$coverageUuid',
    params: { coverageUuid: coverage.uuid },
    viewTransition: { types: [ViewTransitionType.SheetParentToChild] },
  })

// const insistenceRowLink = (insistence: InsistenceResponse) =>
//   linkOptions({
//     from: Route.fullPath,
//     to: '/app/data/groups/$uuid/$policyUuid/$coverageUuid',
//     params: { coverageUuid: insistence.coverage.uuid },
//     viewTransition: { types: [ViewTransitionType.SheetParentToChild] },
//   })

function RouteComponent() {
  const { policyUuid } = Route.useParams()

  return (
    <PolicySheetContent
      policyUuid={policyUuid}
      backLink={backLink}
      coverageRowLink={coverageRowLink}
      // insistenceRowLink={insistenceRowLink}
    />
  )
}
